export const isUnlimitedSubscription = (type: string | number): boolean =>
  Number(type) === 3 || Number(type) === 4
